import type Rollbar from 'rollbar';
import config from './config';

export const rollbarConfig: Rollbar.Configuration = {
  accessToken: config.VITE_ROLLBAR_TOKEN,
  environment: config.MODE,
  captureUncaught: true,
  captureUnhandledRejections: true,
  enabled: !!config.VITE_ROLLBAR_TOKEN && config.PROD,
  payload: {
    client: {
      javascript: {
        code_version: config.VITE_VERSION,
        source_map_enabled: true,
        guess_uncaught_frames: true,
      },
    },
    server: { root: '../../' },
  },
};
